import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BizMenuPageComponent } from './biz-menu-page.component';

/** ルーティング */
const routes: Routes = [
  {
    path: '',
    component: BizMenuPageComponent,
  },
];

/**
 * 初期設定ページルーティングモジュール
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BizMenuPageRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/biz-menu-page-routing.module.ts